import RatingStars from '@/react/components/core-ui/RatingStars';
import SkeletonLoader from '@/react/components/utility/SkeletonLoader';
import type ProductVM from '@/react/view-models/ProductVM';
import type { IRatings } from '@/services/models/ReviewsModel';
import { isPromiseLike } from '@/utils/async-utils';
import StaleWhileRevalidate from '@/utils/StaleWhileRevalidate';
import { memo, type FC } from 'react';

export interface IInternalRatingStarsProps {
  /** The ratings of the product. */
  ratings: ProductVM['ratings'];
}
/** Display the rating stars depending of the type of the `ratings` value. Done
 * this way to primarly display the loading states properly and also to prevent
 * RSC serialization issues. */
const InternalRatingStars: FC<IInternalRatingStarsProps> = memo(
  function InternalRatingStars({ ratings }) {
    if (ratings instanceof StaleWhileRevalidate) {
      if (ratings.pending) {
        return <SkeletonLoader />;
      }
      const ratingsValue = (ratings as StaleWhileRevalidate<IRatings>).value;
      return (
        <RatingStars
          rating={ratingsValue.averageRating}
          count={ratingsValue.numberOfRatings}
        />
      );
    }
    if (isPromiseLike(ratings)) {
      return <SkeletonLoader />;
    }
    return (
      <RatingStars
        rating={ratings?.averageRating ?? 0}
        count={ratings?.numberOfRatings}
      />
    );
  }
);

export default InternalRatingStars;
